










































import Vue, { PropType } from "vue";
import axios from "axios";
import { ErrorResponse } from "@/api/dto/Error";
import VariableInput from "@/components/util/VariableInput.vue";
import { codeLengthLimit, codeRegExp, codeConstraintErrorMessage } from "./constraint";
import FooterSimple from "@/parts/common/FooterSimple.vue";
import { registerPhoneNumber, getPhoneNumber, createAuthCode, getUserIdFromId } from "@/api/UserProfile";
import { validateAuthCode } from "@/api/AuthCode";
import { updateAuthCodeFlag } from "@/jwt";

export default Vue.extend({
  name: "NumberAuthentication",
  components: {
    VariableInput,
    FooterSimple,
  },
  watch: {
    "accountData.code"(code: string) {
      this.inputs["code"].error =
        code.length <= codeLengthLimit && codeRegExp.test(code) ? "" : codeConstraintErrorMessage;
    },
  },
  mounted() {
    this.getAuthPhoneNumber();
    if (this.currentPath == "/signup/number/auth") {
      this.getUserIdFromId();
    } else {
      this.userId = this.getUserId;
    }
  },
  data() {
    return {
      accountData: {
        code: "",
      },
      inputs: {
        code: {
          name: "認証コード",
          type: "text",
          placeholder: "認証コード",
          constraint: codeConstraintErrorMessage,
          error: "",
        },
      },
      generalError: "",
      authPhonNumber: "",
      userId: "",
    };
  },
  computed: {
    /**
     * どれかエラーがあればdisabled
     */
    submitDisabled(): boolean {
      return !(this.accountData.code.length <= codeLengthLimit && codeRegExp.test(this.accountData.code));
    },
    getUserId(): string {
      return this.$store.getters.userProfile.userId;
    },
    getLastFourDigits(): string {
      return this.authPhonNumber.substring(7, this.authPhonNumber.length);
    },
    currentPath(): string {
      return this.$route.path;
    },
  },
  methods: {
    async onClickSubmit() {
      // 新規会員登録
      if (this.currentPath === "/signup/number/auth") {
        try {
          // 認証コードの検証
          let res = await validateAuthCode({
            userId: this.userId,
            authCode: this.accountData.code,
            purpose: "新規会員登録",
          });
          if (!res.isValidated) {
            this.generalError = res.message;
          }

          this.registerPhoneNumber(res.isValidated, this.$route.params.id);
        } catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            this.generalError = resError.message;
          }
        }
      }

      // ログイン
      if (this.currentPath === "/login/number/auth") {
        try {
          // 認証コードの検証
          let result = await validateAuthCode({
            userId: this.getUserId,
            authCode: this.accountData.code,
            purpose: "ログイン",
          });

          // 検証の結果がtrueであれば、ローカルストレージの認証フラグを更新してトップ画面に遷移
          if (result.isValidated) {
            updateAuthCodeFlag("true");
            this.onPushPath("/");
          } else {
            this.generalError = result.message;
            return;
          }
        } catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            this.generalError = resError.message;
          }
        }
      }

      // 二要素認証設定
      if (this.currentPath === "/mypage/settings/twoFactor") {
        try {
          // 認証コードの検証
          let result = await validateAuthCode({
            userId: this.getUserId,
            authCode: this.accountData.code,
            purpose: "二要素認証設定",
          });

          // 検証の結果がtrueであれば、ローカルストレージの認証フラグを更新して設定画面に遷移
          if (result.isValidated) {
            updateAuthCodeFlag("true");
            this.$emit("toast", "二要素認証の設定が完了しました");
            this.onPushPath("/mypage/settings");
          } else {
            this.generalError = result.message;
            return;
          }
        } catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            this.generalError = resError.message;
          }
        }
      }
    },
    /** アカウントIDからユーザーId取得 */
    async getUserIdFromId() {
      let res = await getUserIdFromId({
        id: this.$route.params.id,
      });
      this.userId = res.userId;
    },
    /**  認証コード再送 */
    async resendAuthNumber() {
      await createAuthCode({
        userId: this.userId,
        phoneNumber: this.authPhonNumber,
        purpose: "再送信",
      });
      this.$emit("toast", "認証コードを再送信しました。");
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {});
      this.$emit("pushPath", path);
    },
    /**
     * ユーザの電話番号の取得処理
     */
    async getAuthPhoneNumber() {
      if (this.currentPath == "/login/number/auth" || this.currentPath == "/mypage/settings/twoFactor") {
        // ログイン時
        this.authPhonNumber = await getPhoneNumber({
          userId: this.$store.getters.userProfile.userId,
        });
      } else {
        // 新規会員登録時
        this.authPhonNumber = this.$route.params.phoneNumber;
      }
    },
    /**
     * 電話番号の登録を行う
     * @param result 認証コードの検証結果
     * @param userId ユーザID
     */
    async registerPhoneNumber(result: boolean, userId: string) {
      if (result) {
        try {
          await registerPhoneNumber({
            id: userId,
            phoneNumber: this.authPhonNumber,
          });
          this.onPushPath("/validate/" + this.$route.params.id);
        } catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            this.generalError = resError.message;
          }
        }
      }
    },
  },
});
